// extracted by css-extract-rspack-plugin
export default {"cls1":"useTabs-cls1_8Jj","cls2":"useTabs-cls2_qpx useTabs-cls1_8Jj"};